<div class="d-flex flex-column hotel-bookings">
  <h3 class="bold">Hotel stay</h3>

  <div class="d-flex flex-column hotel-bookings-container">
    @for (booking of hotelBookings; track booking) {
      <div data-id="booking" class="d-flex">
        <img class="mr-6" src="assets/icons/holiday_village.svg" alt="home" />

        <div class="d-flex flex-column">
          <h3 data-id="booking-name" class="bold">{{ booking.name }}</h3>
          <div class="d-flex">
            <p data-id="booking-city">{{ booking.city }}</p>
            <div class="dot-wrapper">
              <ds-dot-separator />
            </div>
            <p data-id="booking-dates-range">
              {{ booking.checkInDate | date: 'MMM d' }} – {{ booking.checkoutDate | date: 'MMM d' }}
            </p>
            <div class="dot-wrapper">
              <ds-dot-separator />
            </div>
            <p data-id="booking-guests">
              {{ booking.guestCount }} {{ booking.guestCount === 1 ? 'guest' : 'guests' }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
